import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '@/common/redux/store';

export type ConsentStatus = 'accepted' | 'rejected' | null;

export interface CookieConsentState {
  consent: ConsentStatus;
}

const initialState: CookieConsentState = {
  consent: null,
};

const cookieConsentSlice = createSlice({
  name: 'cookieConsent',
  initialState,
  reducers: {
    acceptCookies: (state) => {
      state.consent = 'accepted';
    },
    rejectCookies: (state) => {
      state.consent = 'rejected';
    },
    resetCookieConsent: () => initialState,
  },
});

export const { acceptCookies, rejectCookies, resetCookieConsent } = cookieConsentSlice.actions;
export const cookieConsentReducer = cookieConsentSlice.reducer;

export const selectCookieConsent = (state: RootState): ConsentStatus => state.cookieConsent.consent;
export const selectHasCookieConsent = (state: RootState): boolean => state.cookieConsent.consent !== null;
